import { AxiosResponse } from 'axios';
import { nestApiClient } from './api-client';
import {
  ConfigResponse,
  GlobalSearchResponse,
} from '@wwe-portal/entities/global.type';

export const globalSearch = async (searchValue: string) => {
  const response = await nestApiClient.post<GlobalSearchResponse>(
    `/api/v2/profile/search`,
    {
      keyword: searchValue,
    }
  );
  return response.data.data;
};

export const getConfig = async () => {
  const response = await nestApiClient.get<ConfigResponse>(`/config/v2/portal`);
  return response.data.data;
};

export const getPlayer = async (name: string) => {
  const response = await nestApiClient.get<AxiosResponse>(
    `/api/v2/profile/player`,
    {
      params: {
        name,
      },
    }
  );
  return response.data.data;
};
